import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-successful-outcome-modal',
  imports: [],
  templateUrl: './successful-outcome-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessfulOutcomeModalComponent {
  @Input() title!: string;
  @Input() successMessage!: string;

  readonly activeModal = inject(NgbActiveModal);

  onClose(): void {
    this.activeModal.close();
  }
}

